export enum GovernanceTokenType {
  Council = 'Council',
  Community = 'Community',
}
